import React, { useEffect, useState } from "react";
import "./logSettingForm.scss";
import { Button, Col, Divider, Input, Row, Select, Typography } from "antd";
import { GetLogPlatformRes } from "../../interfaces/logPlatform.interface";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import { updateLogPlatformService } from "../../services/logPlatform.service";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { GetPermissionRes } from "../../interfaces/role.interface";
import { PermissionCode } from "../../enum/permission";

interface Props {
  item: GetLogPlatformRes;
  onSubmit: () => void;
}

const LogSettingForm: React.FC<Props> = (props) => {
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<GetLogPlatformRes>({
    id: 0,
    name: "",
    code: "",
    username: "",
    password: "",
    host: "",
    port: "",
    protocol: "",
    schema: "",
    version: "",
  });

  useEffect(() => {
    setData(props.item);
  }, [props.item]);

  const update = async () => {
    try {
      if (!data.name || !data.host || !data.port || !data.protocol) {
        toast.error("مقدار اجباری را وارد کنید");
        return;
      }

      setLoading(true);

      const res = await updateLogPlatformService({
        id: data.id,
        host: data.host,
        code: data.code,
        name: data.name,
        password: data.password,
        port: data.port,
        protocol: data.protocol,
        username: data.username,
        schema: data.schema,
        version: data.version,
      });
      toast.success("اطلاعات با موفقیت ثبت شد");
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="info-box">
      <Row>
        <Col>
          <Typography.Text className="title">{data.name}</Typography.Text>
        </Col>
      </Row>
      <Divider />
      <Row justify={"space-between"} align={"middle"}>
        <Col xs={24} className="input-box">
          <Typography.Text className="title">
            <span style={{ color: "red" }}>*</span> آدرس :{" "}
          </Typography.Text>
          <Input
            className="input"
            value={data.host}
            onChange={(e) => {
              setData({
                ...data,
                host: e.target.value,
              });
            }}
          />
        </Col>
      </Row>
      {data.code === "elastic" && (
        <Row justify={"space-between"} align={"middle"}>
          <Col xs={11} className="input-box">
            <Typography.Text className="title">نام کاربری: </Typography.Text>
            <Input
              className="input"
              value={data.username}
              onChange={(e) => {
                setData({
                  ...data,
                  username: e.target.value,
                });
              }}
            />
          </Col>
          <Col xs={11} className="input-box">
            <Typography.Text className="title">رمز عبور : </Typography.Text>
            <Input.Password
              className="input"
              value={data.password}
              onChange={(e) => {
                setData({
                  ...data,
                  password: e.target.value,
                });
              }}
            />
          </Col>
        </Row>
      )}
      <Row justify={"space-between"} align={"middle"}>
        <Col xs={11} className="input-box">
          <Typography.Text className="title">
            <span style={{ color: "red" }}>*</span>پورت :{" "}
          </Typography.Text>
          <Input
            className="input"
            value={data.port}
            onChange={(e) => {
              setData({
                ...data,
                port: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={11} className="input-box">
          <Typography.Text className="title">
            <span style={{ color: "red" }}>*</span>پروتکل :{" "}
          </Typography.Text>
          <Select
            size="large"
            variant="filled"
            value={data.protocol}
            onSelect={(e) => {
              setData({
                ...data,
                protocol: e,
              });
            }}
            options={[{ value: "UDP" }, { value: "TCP" }]}
            style={{ width: "100%", marginTop: 8 }}
          />
        </Col>
      </Row>
      <Row justify={"space-between"} align={"middle"}>
        {data.code === "elastic" && (
          <Col xs={11} className="input-box">
            <Typography.Text className="title">
              <span style={{ color: "red" }}>*</span>نوع درخواست:{" "}
            </Typography.Text>
            <Select
              size="large"
              variant="filled"
              value={data.schema}
              onSelect={(e) => {
                setData({
                  ...data,
                  schema: e,
                });
              }}
              options={[{ value: "http" }, { value: "https" }]}
              style={{ width: "100%", marginTop: 8 }}
            />
          </Col>
        )}
      </Row>
      <Row justify={"space-between"} align={"middle"}>
        {userPermissions.find(
          (p) => p.code === PermissionCode.updateLogPlatform
        ) && (
          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={update}
            style={{ padding: 22, boxShadow: "none", marginTop: 25 }}
          >
            ذخیره
          </Button>
        )}
      </Row>
    </div>
  );
};

export default LogSettingForm;
